import { render, staticRenderFns } from "./Apartmentscheme.vue?vue&type=template&id=b897d9d4&scoped=true&"
import script from "./Apartmentscheme.vue?vue&type=script&lang=js&"
export * from "./Apartmentscheme.vue?vue&type=script&lang=js&"
import style0 from "./Apartmentscheme.vue?vue&type=style&index=0&id=b897d9d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b897d9d4",
  null
  
)

export default component.exports